import BlogPostPreviewTile from '@root/joinroot.com/src/components/blog/blog-post-preview-tile';
import CategorySection from '@root/joinroot.com/src/components/blog/category-section';
import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import TileLayoutModel from '@root/joinroot.com/src/models/tile-layout';

export default function BlogRelatedPostsSectionBlock({ content }) {
  return (
    <div data-testid={'blogRelatedPostsSectionBlock'}>
      <CategorySection
        layout={TileLayoutModel.SLIDING}
        sectionTitle={'Related Posts'}
      >
        {content.relatedPosts.map(({
          previewTitle,
          previewBody,
          previewImage: { fluid },
          imageAltText,
          customDateCreated,
          publishingMetadata: { slug },
          blogCategory,
        }) => {
          return (
            <BlogPostPreviewTile
              categorySlug={blogCategory[0].publishingMetadata.slug}
              categoryTitle={blogCategory[0].categoryTitle}
              dateCreated={customDateCreated}
              imageAltText={imageAltText ?? ''}
              key={slug}
              layout={TileLayoutModel.SLIDING}
              previewBody={previewBody}
              previewImage={fluid}
              previewTitle={previewTitle}
              slug={slug}
            />
          );
        })}
      </CategorySection>
    </div>
  );
}

BlogRelatedPostsSectionBlock.propTypes = {
  content: PropTypes.shape({
    relatedPosts: PropTypes.arrayOf(
      PropTypes.shape({
        publishingMetadata: PropTypes.shape({
          slug: PropTypes.string.isRequired,
        }).isRequired,
        blogCategory: PropTypes.arrayOf(
          PropTypes.shape({
            categoryTitle: PropTypes.string.isRequired,
            publishingMetadata: PropTypes.shape({
              slug: PropTypes.string.isRequired,
            }).isRequired,
          }).isRequired,
        ).isRequired,
        previewTitle: PropTypes.string.isRequired,
        previewBody: PropTypes.string.isRequired,
        previewImage: PropTypes.shape({
          fluid: PropTypes.object.isRequired,
        }).isRequired,
        imageAltText: PropTypes.string,
        customDateCreated: PropTypes.string,
      }).isRequired,
    ).isRequired,
  }).isRequired,
};

